angular.module 'zc.core'

# taken from http://stackoverflow.com/questions/18604374/angularjs-orderby-with-empty-field
.filter "emptyToEnd", ($parse) ->
  return (array, key, reverse) ->
    return if !angular.isArray(array)
    keyFn = $parse(key)
    empty = []
    present = []

    angular.forEach array, (item) ->
      val = keyFn(item)
      if angular.isUndefined(val) || val == null
        empty.push(item)
      else
        present.push(item)

    if reverse
      return present.concat(empty)
    else
      return empty.concat(present)



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/filters/empty_to_end.js.coffee